module.exports = __webpack_public_path__ + "img/fadian.a052195a.svg";